import React from 'react';
import PropTypes from 'prop-types';
import Iframe from 'react-iframe';

const TourItem = ({ src }) => (
  <div className="pano-carousel-container">
    <Iframe
      url={src}
      width="100%"
      height="100%"
      id="myId"
      frameBorder="0"
      allowFullScreen
      display="initial"
      position="relative"
    />
  </div>
  );

TourItem.propTypes = {
  src: PropTypes.string.isRequired,
};

export default TourItem;
